import { OPEN_DATE_PICKER, CLOSE_DATE_PICKER, OPEN_DATETIME_PICKER, CLOSE_DATETIME_PICKER } from './actionTypes';

export const openDatePickerAction = ({
  onChange,
  initialDate,
  clearable = true,
  autoOk = true,
  setEODTime = true,
  setSODTime = false,
  minDate = null,
  maxDate = null,
}) => ({
  type: OPEN_DATE_PICKER,
  data: {
    onChange,
    initialDate,
    clearable,
    autoOk,
    setEODTime,
    setSODTime,
    minDate,
    maxDate,
  },
});

export const closeDatePickerAction = () => ({
  type: CLOSE_DATE_PICKER,
});

export const openDateTimePickerAction = ({
  onChange,
  initialDate,
  endDate,
  clearable = true,
  autoOk = false,
  openTo,
  minDate = null,
  isOneOnOneDatePicker,
}) => ({
  type: OPEN_DATETIME_PICKER,
  data: {
    onChange,
    initialDate,
    endDate,
    clearable,
    autoOk,
    openTo,
    minDate,
    isOneOnOneDatePicker,
  },
});

export const closeDateTimePickerAction = () => ({
  type: CLOSE_DATETIME_PICKER,
});
